import { entity } from "./Connection"

export const AccountSubscriptionPlanPricingEntity = entity("AccountSubscriptionPlanPricing");
